import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Admin auth token (matches backend ADMIN_UPLOAD_TOKEN)
const ADMIN_TOKEN = 'EcomSeekho56:Ecom@567';

/**
 * Upload a file (image) to backend object storage.
 * Returns { id, url, path, size, content_type }.
 */
export const uploadFile = async (file, { onProgress } = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await axios.post(`${API}/upload`, formData, {
    withCredentials: true,
    headers: {
      'X-Admin-Auth': ADMIN_TOKEN,
    },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  return res.data;
};

/**
 * Convert relative /api/files/{id} url to absolute URL usable in <img src>.
 */
export const fileUrl = (idOrUrl) => {
  if (!idOrUrl) return '';
  if (idOrUrl.startsWith('http') || idOrUrl.startsWith('data:')) return idOrUrl;
  if (idOrUrl.startsWith('/api/')) return `${BACKEND_URL}${idOrUrl}`;
  // assume it's a file id
  return `${API}/files/${idOrUrl}`;
};
